module.exports = __webpack_public_path__ + "media/newstyle/images/instagram3-19f7f8d2678dc37e965eaaf192e93f04.png";